import { BehaviorSubject } from '../../core/observer/BehaviorSubject';
import {
  BIG_WIN_STATE, GAME_SCENE_STATE,
  HISTORY_ICON_STATE,
  INFORMATION_ICON_STATE,
  SCREEN_TRANSACTION_STATE,
} from '../../stateManagment/gameState';
import { gameService } from '../GameService';
import { userService } from './UserService';
import { bonusSpinResponseHelper } from './BonusSpinResponseHelper';
import { historyHelperService } from './HistoryHelperService';
import { GAME_SCENE } from '../../core/constats';
import { delay } from '../../core/helpers/delay';
import {spinButtonHelper} from "./SpinButtonHelper";

class PopupHelper {
  constructor() {
    this.BUY_BONUS_POPUP_STATE = new BehaviorSubject(false);
    this.CONGRATULATIONS_POPUP_STATE = new BehaviorSubject(false);
    this.CONGRATULATIONS_BONUS_POPUP_STATE = new BehaviorSubject(false);
    this._popupsStates = [
      this.BUY_BONUS_POPUP_STATE,
      this.CONGRATULATIONS_POPUP_STATE,
      this.CONGRATULATIONS_BONUS_POPUP_STATE,
    ];
  }

  get buyBonusPopupState() {
    return this.BUY_BONUS_POPUP_STATE.getValue();
  }

  setBuyBonusPopupState(value) {
    this.BUY_BONUS_POPUP_STATE.next(value);
  }

  subscribeBuyBonusPopup(...args) {
    return this.BUY_BONUS_POPUP_STATE.subscribe(...args);
  }

  get congratulationsPopupState() {
    return this.CONGRATULATIONS_POPUP_STATE.getValue();
  }

  subscribeCongratulationsPopup(...args) {
    return this.CONGRATULATIONS_POPUP_STATE.subscribe(...args);
  }

  setCongratulationsPopupState(value) {
    this.CONGRATULATIONS_POPUP_STATE.next(value);
  }

  get congratulationsBonusPopupState() {
    return this.CONGRATULATIONS_BONUS_POPUP_STATE.getValue();
  }

  subscribeCongratulationsBonusPopup(...args) {
    return this.CONGRATULATIONS_BONUS_POPUP_STATE.subscribe(...args);
  }

  setCongratulationsBonusPopupState(value) {
    this.CONGRATULATIONS_BONUS_POPUP_STATE.next(value);
  }

  subscribe(callback, initialCall = false) {
    let list = [
      ...this._popupsStates,
      BIG_WIN_STATE,
      SCREEN_TRANSACTION_STATE,
    ];
    const subscribers = list.reduce((subscriber, observer) => {
      const obs = observer.subscribe((s) => {
        const state = list.map(obs => obs.getValue()).some(val => val);
        callback(state);
      }, initialCall);
      return subscriber.concat(obs);
    }, []);
    return {
      unsubscribe() {
        subscribers.forEach(sub => sub.unsubscribe());
      },
    };
  }

  reset() {
    this.BUY_BONUS_POPUP_STATE.next(false);
    this.CONGRATULATIONS_POPUP_STATE.next(false);
    this.CONGRATULATIONS_BONUS_POPUP_STATE.next(false);
  }

  checkAndClosePopups() {
    if (this.congratulationsBonusPopupState) {
      this.setCongratulationsBonusPopupState(false);
      delay(() => {
        GAME_SCENE_STATE.next(GAME_SCENE.PRE_BONUS);
      }, 1000)
    } else if (this.buyBonusPopupState) {
      this.setBuyBonusPopupState(false);
      return true;
    } else if (this.congratulationsPopupState) {
      popupHelper.setCongratulationsPopupState(false);
      if (!gameService.isRealMode) {
        userService.plusBalance(bonusSpinResponseHelper.getData()?.totalWinAmount);
      }
      historyHelperService.updateHistory();
      GAME_SCENE_STATE.next(GAME_SCENE.MAIN);
      spinButtonHelper.enable()
      return true;
    } else if (INFORMATION_ICON_STATE.getValue()) {
      INFORMATION_ICON_STATE.next(false);
      return true;
    } else if (HISTORY_ICON_STATE.getValue()) {
      HISTORY_ICON_STATE.next(false);
      return true;
    }
    return false;
  }
}

export const popupHelper = new PopupHelper();
